import React, {useContext} from "react";
import {Card, Typography, Empty, List, Button, Divider} from "antd";
import {WindowContext} from "@web/hooks/context";
// import ContactActivityListItem from "./ContactActivityListItem";
import Loading from "./Loading";
import Pager from "@web/ui/containers/Pager";
import LineConnector from "./LineConnector";
import PropTypes from "prop-types";
// import ActivityData from "@web/ui/containers/ActivityData";
// import LaunchSourceManagerButton from "./LaunchSourceManagerButton";
import AppsListItem from "./AppsListItem";
import ContentData from "@web/ui/containers/ContentData";
import CollectionItemData from '@web/ui/containers/CollectionItemData';
// import {RightArrowOutlined} from "@web/assets/icons";

AppsList.propTypes = {
  // collectionId: PropTypes.string.isRequired,
  list: PropTypes.array,
  pageNext: PropTypes.func,
  hasMore: PropTypes.bool,
  onClick: PropTypes.func,
}

function AppsList(props) {
  const [isMobile,, height] = useContext(WindowContext);
  return <div
    id="services-contacts-scroll-target"
    style={{
      height: height - 3,
      overflow: 'auto',
    }}>
    <Pager
      height={height - 3}
      loader={<Loading inline />}
      length={props.list?.length || 0}
      hasMore={props.hasMore}
      endMessage={
        !!props.list?.length &&
        <div
          className="space space-center-y"
          style={{position: "relative", top: "6px", left: 26}}
        >
          <h6 className="muted">End</h6>&nbsp;<LineConnector />
        </div>
      }
      pageNext={props.pageNext}
      scrollContainerId="services-contacts-scroll-target"
    >
      <List
        header={
          !isMobile && <Divider className="small-bottom hidden small-top" />
        }
        className="services-contacts-list list-empty-no-padding list-item-no-divider"
        dataSource={props.list}
        renderItem={(path) => {
          return <CollectionItemData
            component={AppsListItem}
            onClick={props.onClick}
            path={path}
            dataField="app"
          />;
        }}
        locale={{
          emptyText: <Empty
            className="add-integrations-empty-wrapper space space-col middle"
            description={null}
            image={null}
            imageStyle={{display: "none"}}
            style={{width: "100%", maxWidth: "100%", height: height - 140, margin: "0 auto"}}
          >
            {/*<div className="bgx cursor-pointer" style={{width: "100%", padding: "12px 0"}}>*/}
            {/*  <LaunchSourceManagerButton key="sources-manager-x" serviceId={"contacts"}>*/}
            {/*    <Typography.Title style={{marginBottom: 11}}>Apps</Typography.Title>*/}
            {/*  </LaunchSourceManagerButton>*/}
            {/*</div>*/}

            {/*<Card title="Connect your Email" className="card-simple card-rounded card-no-header" bordered={false}>*/}
            {/*  <Link to="/">Connect your email to use assistant features</Link>*/}
            {/*  /!*<SourceManager group={{sourceIds:["gmail", "outlook", "web"]}} serviceId="contacts" />*!/*/}
            {/*</Card>*/}
          </Empty>
        }}
        // footer={
        // <div className="bgx cursor-pointer space space-center-x" style={{padding: "12px 0"}}>
        //   <LaunchSourceManagerButton key="sources-manager-x" serviceId={"apps"}>
        //     <Typography.Title style={{marginBottom: 11}}>Browse Apps</Typography.Title>
        //   </LaunchSourceManagerButton>
        // </div>}
      />
    </Pager>
  </div>
}

export default AppsList;
